import { PkgWarehouse } from '@/api/user-package/types/UserPkg'

export enum CouponTypeEnum {
  Percentage = 'PERCENTAGE',
  Fixed = 'FIXED',
  MktUniteFee = 'MktUniteFee',
  WarehouseFees = 'WarehouseFees',
}
export interface CouponPayment {
  warehouse?: string
  couponRevenue?: number
  date: string
  id?: string
  shippingPaid?: number
  couponCode?: string
  refundAmount?: number
}

export interface Coupon {
  country: (PkgWarehouse | 'all')[]
  minPayment: number
  totalFinalPayments: number
  limitedUses: string
  expiredAt: string
  timesUsed: number
  createdAt: string
  familyName: string
  usersAllowed: string[]
  value: string
  code: string
  shippingMethod: string
  revenue: string
  updatedAt: string
  notes: string
  productCategory: string
  id: string
  refUserId: string
  limitedUsesForUser: string
  type: CouponTypeEnum
  payments?: CouponPayment[]
}
